/* eslint-disable react-hooks/rules-of-hooks */
import useQueryParams from "../hooks/useQueryParams"

export default function getPerPage(name: string, defaultPerPage) {
  const query = useQueryParams()
  const queryPerPage = query.get(name + "perPage")

  return queryPerPage ? parseInt(queryPerPage.toString(), 10) : defaultPerPage
}
